module.exports = __webpack_public_path__ + "img/sortup.7c856cdb.svg";